var map = {
	"./New folder/next-arrow2.png": "42be",
	"./arrow-double.png": "dae5",
	"./arrow-double5.png": "8fd0",
	"./arrow-down-green.png": "75da",
	"./arrow-green-right.png": "da37",
	"./arrow-green.png": "98e8",
	"./arrow-long.png": "0a65",
	"./arrow-yellow.png": "d2c9",
	"./arrow.svg": "212a",
	"./bg-icon.svg": "6038",
	"./dellotie.svg": "840b",
	"./dellotie1.svg": "d266",
	"./digital-chart.png": "05cb",
	"./digital-chart_ar.png": "5fbc",
	"./icon1.svg": "45b7",
	"./icon2.svg": "d89e",
	"./icon3.svg": "344e",
	"./icon4.svg": "99f1",
	"./icon5.svg": "67b5",
	"./icon6.svg": "1a455",
	"./icon7.svg": "a65b",
	"./icon8.svg": "e6b3",
	"./prev-arrow.png": "887b",
	"./rocket.svg": "9d70",
	"./setting.svg": "44e8",
	"./sound.svg": "9cf1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1407";